import React from 'react'
import PropTypes from 'prop-types'

const RadioButtonContainer = ({title, data, name, onChange, checked, disabled}) => {
  return (
    <div className={`radio-button_container ${disabled && 'disabled'}`}>
      <span className="title-radiobutton-container">{title || ''}</span>
      <div className="radio-container">
        {data.map((item) => (
          <div key={`${title}-${item.id}`} className='radioButton'>
            <input
              type="radio"
              id={item.id}
              name={name}
              onChange={onChange}
              checked={checked === item.id}
              disabled={disabled}
            />
            <label htmlFor={item.id}>{item.title}</label>
          </div>
        ))}
      </div>
    </div>
  )
}

RadioButtonContainer.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.string,
  disabled: PropTypes.bool
}

export default RadioButtonContainer